export default "__VITE_ASSET__DRY3LdaI__"